import { useTranslation } from "react-i18next";
import { Car } from "lucide-react";
import { useAppSelector } from "../../../app/hooks";
import { selectIsOrgOwnerOrAdmin } from "../../authentication/authenticationSlice";
import FahrschulePresetForm from "../../../components/organization/FahrschulePresetForm";

/**
 * Organization settings card (Owner/Admin): set the school up as a Fahrschule in one
 * action, or apply again later — what already exists is skipped.
 */
const FahrschulePresetCard = () => {
  const { t } = useTranslation();
  const canEdit = useAppSelector(selectIsOrgOwnerOrAdmin);

  if (!canEdit) return null;

  return (
    <div className="with-border rounded-2xl p-4 lg:p-6">
      <div className="mb-4 flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-95 text-primary-50 dark:bg-primary-30 dark:text-primary-80">
          <Car size={20} strokeWidth={2} />
        </span>
        <div className="min-w-0">
          <h2 className="text-lg font-semibold leading-tight">{t("preset.fahrschule.cardTitle")}</h2>
          <p className="mt-0.5 text-sm text-grey-50 dark:text-grey-70">{t("preset.fahrschule.cardIntro")}</p>
        </div>
      </div>
      <FahrschulePresetForm />
    </div>
  );
};

export default FahrschulePresetCard;
